import { render, staticRenderFns } from "./BackOfLicenseDesktopSvg.vue?vue&type=template&id=8046fe94&"
import script from "./BackOfLicenseDesktopSvg.vue?vue&type=script&lang=ts&"
export * from "./BackOfLicenseDesktopSvg.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports